import { module } from 'modujs';
import lottie from "lottie-web";
import { getMediaType } from '../utils/medias';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        if (getMediaType(this.el) == 'lottie') {
            let lottieElt = this.el.querySelector('[data-lottie-src]');
            if (lottieElt) {
                let anim = lottie.loadAnimation({
                    container: lottieElt,
                    renderer: 'svg',
                    loop: true,
                    autoplay: false,
                    path: lottieElt.getAttribute('data-lottie-src'),
                });
                lottieElt.setAttribute('data-lottie-id', anim.animationID);
            }
        }
    }
}
